import { OnfidoTokenDTO } from '@app/landing-videoselfing/model/videoselfing-model';
import { VideoSelfingStore } from '../landing-videoselfing/services/videoselfing.store';
import { Component, OnInit } from '@angular/core';
import { Onfido } from 'onfido-sdk-ui';
import { Router } from '@angular/router';

@Component({
  selector: 'scf-onfido-videoselfing',
  templateUrl: './landing-onfido-videoselfing.component.html',
  styleUrls: ['./landing-onfido-videoselfing.component.scss'],
})
export class LandingOnfidoVideoselfingComponent implements OnInit {
  constructor(private videoselfingStore: VideoSelfingStore, private router: Router) {}

  public applicantId: OnfidoTokenDTO;

  ngOnInit() {
    this.applicantId = this.videoselfingStore.getApplicantId();
  }

  ngAfterViewInit() {
    if (this.applicantId) this.loadOnfido();
  }

  loadOnfido() {
    const self = this;
    Onfido.init({
      token: this.applicantId.sdkToken,
      language: 'es',
      containerId: 'onfido-mount',
      onComplete: function (data: any) {
        console.log('everything is complete');
        self.videoselfingStore
          .getHistoricalOnfido(self.applicantId?.applicantId, 'FINISH')
          .then((result: any) => {
            console.log('Proceso finalizado correctamente');
          })
          .catch((error) => {
            console.log(error);
            self.videoselfingStore.setOnfidoError(true);
            self.router.navigate(['/landing-finish-videoselfing']);
          });
      },
      onError: (e: any) => {
        self.videoselfingStore.setOnfidoError(true);
        self.router.navigate(['/landing-finish-videoselfing']);
      },
      workflowRunId: this.applicantId?.workFlowRunId,
    });
  }
}
